import { ComponentPropsWithoutRef } from 'react';
import { Close } from '../../icons';
import { cn } from '../../lib/utils';
import { Icon } from '../icon/icon';

type ClearButtonProps = {
  disabled: boolean;
  onClick: ComponentPropsWithoutRef<'button'>['onClick'];
  className?: string;
};

export const ClearButton = ({ disabled, onClick, className }: ClearButtonProps) => (
  <button
    type="button"
    aria-label="Clear input"
    disabled={disabled}
    onClick={onClick}
    className={cn(
      'absolute top-1/2 right-2 flex size-8 -translate-y-1/2 items-center justify-center rounded-lg text-space-60 transition-colors hover:not-disabled:text-space disabled:cursor-not-allowed',
      'focus-visible:ring-[3px] focus-visible:ring-focus-ring focus-visible:ring-offset-2 focus-visible:outline-none',
      className,
    )}>
    <Icon icon={Close} className="size-4" />
  </button>
);
